export const COPY = {
  en: {
    title: "GDHM Assistant",
    subtitle: "Powered by Amazon Bedrock",
    close: "Close GDHM Assistant",
    open: "Open GDHM Assistant",
    launcherLabel: "Ask GDHM",
    launcherPrompt: "Want to know more? Ask the GDHM AI Assistant!",
    dismissInvite: "Dismiss assistant invite",
    assistantLabel: "GDHM Assistant",
    userLabel: "You",
    sources: "Sources",
    placeholder: "Ask a question...",
    disclaimer: "AI can make mistakes.",
    welcome:
      "Hello! I can answer questions about digital health maturity across 100+ countries, including trends, regional comparisons, and indicator breakdowns. What would you like to explore?",
    thinking: "Thinking...",
    emptyResponse: "I did not receive any answer text. Please try again.",
    errorReply: "The answer stream stopped before completion.",
    streamError: "The connection was interrupted before the answer finished.",
    retryNotice: "You can retry the last question.",
    retry: "Retry",
    copyMessageAction: "Copy message",
    downloadConversationAction: "Download conversation",
    downloadConversationLabel: "Download chat",
    copiedMessage: "Copied",
    downloadedConversation: "Conversation download started.",
    confirmDownloadConversation: "Download the entire conversation?",
    actionError: "That action is not available right now.",
  },
  fr: {
    title: "GDHM Assistant",
    subtitle: "Powered by Amazon Bedrock",
    close: "Fermer GDHM Assistant",
    open: "Ouvrir GDHM Assistant",
    launcherLabel: "Ask GDHM",
    launcherPrompt:
      "Vous voulez en savoir plus ? Demandez à l'assistant IA GDHM !",
    dismissInvite: "Masquer l'invitation de l'assistant",
    assistantLabel: "GDHM Assistant",
    userLabel: "Vous",
    sources: "Sources",
    placeholder: "Posez une question...",
    disclaimer: "L'IA peut se tromper.",
    welcome: "Comment puis-je vous aider aujourd'hui ?",
    thinking: "Réflexion…",
    emptyResponse: "Je n'ai recu aucun texte de reponse. Veuillez reessayer.",
    errorReply: "Le flux de reponse s'est arrete avant la fin.",
    streamError: "La connexion a ete interrompue avant la fin de la reponse.",
    retryNotice: "Vous pouvez relancer la derniere question.",
    retry: "Reessayer",
    copyMessageAction: "Copier le message",
    downloadConversationAction: "Télécharger la conversation",
    downloadConversationLabel: "Télécharger le chat",
    copiedMessage: "Copie",
    downloadedConversation: "Telechargement de la conversation demarre.",
    confirmDownloadConversation: "Telecharger toute la conversation ?",
    actionError: "Cette action n'est pas disponible pour le moment.",
  },
  es: {
    title: "GDHM Assistant",
    subtitle: "Powered by Amazon Bedrock",
    close: "Cerrar GDHM Assistant",
    open: "Abrir GDHM Assistant",
    launcherLabel: "Ask GDHM",
    launcherPrompt:
      "¿Quieres saber más? Pregúntale al asistente de IA de GDHM.",
    dismissInvite: "Descartar invitación del asistente",
    assistantLabel: "GDHM Assistant",
    userLabel: "Tu",
    sources: "Fuentes",
    placeholder: "Haz una pregunta...",
    disclaimer: "La IA puede equivocarse.",
    welcome: "Como puedo ayudarte hoy?",
    thinking: "Pensando...",
    emptyResponse: "No recibi texto de respuesta. Intenta de nuevo.",
    errorReply: "La respuesta se interrumpio antes de completarse.",
    streamError:
      "La conexion se interrumpio antes de que terminara la respuesta.",
    retryNotice: "Puedes volver a intentar la ultima pregunta.",
    retry: "Reintentar",
    copyMessageAction: "Copiar mensaje",
    downloadConversationAction: "Descargar conversación",
    downloadConversationLabel: "Descargar chat",
    copiedMessage: "Copiado",
    downloadedConversation: "Descarga de la conversacion iniciada.",
    confirmDownloadConversation: "Descargar toda la conversacion?",
    actionError: "Esa accion no esta disponible ahora mismo.",
  },
  pt: {
    title: "GDHM Assistant",
    subtitle: "Powered by Amazon Bedrock",
    close: "Fechar GDHM Assistant",
    open: "Abrir GDHM Assistant",
    launcherLabel: "Ask GDHM",
    launcherPrompt:
      "Quer saber mais? Pergunte ao assistente de IA do GDHM!",
    dismissInvite: "Dispensar convite do assistente",
    assistantLabel: "GDHM Assistant",
    userLabel: "Voce",
    sources: "Fontes",
    placeholder: "Faca uma pergunta...",
    disclaimer: "A IA pode errar.",
    welcome: "Como posso ajudar voce hoje?",
    thinking: "A pensar…",
    emptyResponse: "Nao recebi texto de resposta. Tente novamente.",
    errorReply: "O fluxo da resposta foi interrompido antes do fim.",
    streamError: "A conexao foi interrompida antes do termino da resposta.",
    retryNotice: "Voce pode tentar novamente a ultima pergunta.",
    retry: "Tentar novamente",
    copyMessageAction: "Copiar mensagem",
    downloadConversationAction: "Baixar conversa",
    downloadConversationLabel: "Baixar chat",
    copiedMessage: "Copiada",
    downloadedConversation: "Download da conversa iniciado.",
    confirmDownloadConversation: "Baixar a conversa inteira?",
    actionError: "Essa acao nao esta disponivel agora.",
  },
  ar: {
    title: "GDHM Assistant",
    subtitle: "Powered by Amazon Bedrock",
    close: "اغلاق GDHM Assistant",
    open: "فتح GDHM Assistant",
    launcherLabel: "Ask GDHM",
    launcherPrompt: "هل تريد معرفة المزيد؟ اسأل مساعد GDHM للذكاء الاصطناعي!",
    dismissInvite: "إخفاء دعوة المساعد",
    assistantLabel: "GDHM Assistant",
    userLabel: "أنت",
    sources: "المصادر",
    placeholder: "اطرح سؤالا...",
    disclaimer: "قد يخطئ الذكاء الاصطناعي.",
    welcome: "كيف يمكنني مساعدتك اليوم؟",
    thinking: "جارٍ التفكير...",
    emptyResponse: "لم يصلني نص اجابة. يرجى المحاولة مرة اخرى.",
    errorReply: "توقف تدفق الاجابة قبل اكتماله.",
    streamError: "انقطع الاتصال قبل اكتمال الاجابة.",
    retryNotice: "يمكنك اعادة محاولة اخر سؤال.",
    retry: "اعادة المحاولة",
    copyMessageAction: "نسخ الرسالة",
    downloadConversationAction: "تنزيل المحادثة",
    downloadConversationLabel: "تنزيل الدردشة",
    copiedMessage: "تم النسخ",
    downloadedConversation: "تم بدء تنزيل المحادثة.",
    confirmDownloadConversation: "هل تريد تنزيل المحادثة كاملة؟",
    actionError: "هذا الاجراء غير متاح حاليا.",
  },
};
